const VctFundStatus = Object.freeze({
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    ACQUIRED: 'ACQUIRED'
});

export default VctFundStatus;
